import type { ErrorType } from '../../shared/lib/axios/client'
import type {
  AccessTokenResponse,
  AuthControllerGoogleCallbackParams,
  AuthControllerValidateResetPasswordParams,
  AuthControllerVerifyEmailParams,
  ForgotPasswordDto,
  GoogleCallbackResponse,
  GoogleSignupDto,
  RegisterDto,
  ResendEmailBodyDto,
  ResetPasswordDto,
  SignInDto,
  SwitchOrganisationDto,
} from '.././types'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Detelio API specification
 * openAPI specification for Detelio API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'

import { axiosClient } from '../../shared/lib/axios/client'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

export const authControllerRegister = (
  registerDto: RegisterDto,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<void>(
    {
      url: `https://api.detelio.ai/auth/register`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: registerDto,
      signal,
    },
    options,
  )
}

export const getAuthControllerRegisterMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerRegister>>,
    TError,
    { data: RegisterDto },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerRegister>>,
  TError,
  { data: RegisterDto },
  TContext
> => {
  const mutationKey = ['authControllerRegister']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerRegister>>,
    { data: RegisterDto }
  > = (props) => {
    const { data } = props ?? {}

    return authControllerRegister(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AuthControllerRegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerRegister>>
>
export type AuthControllerRegisterMutationBody = RegisterDto
export type AuthControllerRegisterMutationError = ErrorType<unknown>

export const useAuthControllerRegister = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerRegister>>,
      TError,
      { data: RegisterDto },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerRegister>>,
  TError,
  { data: RegisterDto },
  TContext
> => {
  const mutationOptions = getAuthControllerRegisterMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const authControllerVerifyEmail = (
  params: AuthControllerVerifyEmailParams,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<void>(
    { url: `https://api.detelio.ai/auth/verify-email`, method: 'GET', params, signal },
    options,
  )
}

export const getAuthControllerVerifyEmailQueryKey = (params?: AuthControllerVerifyEmailParams) => {
  return [`https://api.detelio.ai/auth/verify-email`, ...(params ? [params] : [])] as const
}

export const getAuthControllerVerifyEmailQueryOptions = <
  TData = Awaited<ReturnType<typeof authControllerVerifyEmail>>,
  TError = ErrorType<unknown>,
>(
  params: AuthControllerVerifyEmailParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerVerifyEmail>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAuthControllerVerifyEmailQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerVerifyEmail>>> = ({ signal }) =>
    authControllerVerifyEmail(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authControllerVerifyEmail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthControllerVerifyEmailQueryResult = NonNullable<
  Awaited<ReturnType<typeof authControllerVerifyEmail>>
>
export type AuthControllerVerifyEmailQueryError = ErrorType<unknown>

export function useAuthControllerVerifyEmail<
  TData = Awaited<ReturnType<typeof authControllerVerifyEmail>>,
  TError = ErrorType<unknown>,
>(
  params: AuthControllerVerifyEmailParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerVerifyEmail>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerVerifyEmail>>,
          TError,
          Awaited<ReturnType<typeof authControllerVerifyEmail>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthControllerVerifyEmail<
  TData = Awaited<ReturnType<typeof authControllerVerifyEmail>>,
  TError = ErrorType<unknown>,
>(
  params: AuthControllerVerifyEmailParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerVerifyEmail>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerVerifyEmail>>,
          TError,
          Awaited<ReturnType<typeof authControllerVerifyEmail>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthControllerVerifyEmail<
  TData = Awaited<ReturnType<typeof authControllerVerifyEmail>>,
  TError = ErrorType<unknown>,
>(
  params: AuthControllerVerifyEmailParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerVerifyEmail>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAuthControllerVerifyEmail<
  TData = Awaited<ReturnType<typeof authControllerVerifyEmail>>,
  TError = ErrorType<unknown>,
>(
  params: AuthControllerVerifyEmailParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerVerifyEmail>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAuthControllerVerifyEmailQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const authControllerSignIn = (
  signInDto: SignInDto,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<AccessTokenResponse>(
    {
      url: `https://api.detelio.ai/auth/login`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: signInDto,
      signal,
    },
    options,
  )
}

export const getAuthControllerSignInMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerSignIn>>,
    TError,
    { data: SignInDto },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerSignIn>>,
  TError,
  { data: SignInDto },
  TContext
> => {
  const mutationKey = ['authControllerSignIn']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerSignIn>>,
    { data: SignInDto }
  > = (props) => {
    const { data } = props ?? {}

    return authControllerSignIn(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AuthControllerSignInMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerSignIn>>>
export type AuthControllerSignInMutationBody = SignInDto
export type AuthControllerSignInMutationError = ErrorType<unknown>

export const useAuthControllerSignIn = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerSignIn>>,
      TError,
      { data: SignInDto },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerSignIn>>,
  TError,
  { data: SignInDto },
  TContext
> => {
  const mutationOptions = getAuthControllerSignInMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const authControllerRefreshUserToken = (options?: SecondParameter<typeof axiosClient>) => {
  return axiosClient<AccessTokenResponse>(
    { url: `https://api.detelio.ai/auth/refresh-token`, method: 'PATCH' },
    options,
  )
}

export const getAuthControllerRefreshUserTokenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerRefreshUserToken>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerRefreshUserToken>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['authControllerRefreshUserToken']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerRefreshUserToken>>,
    void
  > = () => {
    return authControllerRefreshUserToken(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AuthControllerRefreshUserTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerRefreshUserToken>>
>

export type AuthControllerRefreshUserTokenMutationError = ErrorType<unknown>

export const useAuthControllerRefreshUserToken = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerRefreshUserToken>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof authControllerRefreshUserToken>>, TError, void, TContext> => {
  const mutationOptions = getAuthControllerRefreshUserTokenMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const authControllerSwitchOrganisation = (
  switchOrganisationDto: SwitchOrganisationDto,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<AccessTokenResponse>(
    {
      url: `https://api.detelio.ai/auth/switch-organisation`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: switchOrganisationDto,
      signal,
    },
    options,
  )
}

export const getAuthControllerSwitchOrganisationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerSwitchOrganisation>>,
    TError,
    { data: SwitchOrganisationDto },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerSwitchOrganisation>>,
  TError,
  { data: SwitchOrganisationDto },
  TContext
> => {
  const mutationKey = ['authControllerSwitchOrganisation']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerSwitchOrganisation>>,
    { data: SwitchOrganisationDto }
  > = (props) => {
    const { data } = props ?? {}

    return authControllerSwitchOrganisation(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AuthControllerSwitchOrganisationMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerSwitchOrganisation>>
>
export type AuthControllerSwitchOrganisationMutationBody = SwitchOrganisationDto
export type AuthControllerSwitchOrganisationMutationError = ErrorType<unknown>

export const useAuthControllerSwitchOrganisation = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerSwitchOrganisation>>,
      TError,
      { data: SwitchOrganisationDto },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerSwitchOrganisation>>,
  TError,
  { data: SwitchOrganisationDto },
  TContext
> => {
  const mutationOptions = getAuthControllerSwitchOrganisationMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const authControllerLogout = (options?: SecondParameter<typeof axiosClient>) => {
  return axiosClient<void>({ url: `https://api.detelio.ai/auth/logout`, method: 'DELETE' }, options)
}

export const getAuthControllerLogoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof authControllerLogout>>, TError, void, TContext>
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<Awaited<ReturnType<typeof authControllerLogout>>, TError, void, TContext> => {
  const mutationKey = ['authControllerLogout']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerLogout>>, void> = () => {
    return authControllerLogout(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AuthControllerLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerLogout>>>

export type AuthControllerLogoutMutationError = ErrorType<unknown>

export const useAuthControllerLogout = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof authControllerLogout>>, TError, void, TContext>
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof authControllerLogout>>, TError, void, TContext> => {
  const mutationOptions = getAuthControllerLogoutMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const authControllerForgotPassword = (
  forgotPasswordDto: ForgotPasswordDto,
  options?: SecondParameter<typeof axiosClient>,
) => {
  return axiosClient<void>(
    {
      url: `https://api.detelio.ai/auth/forgot-password`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: forgotPasswordDto,
    },
    options,
  )
}

export const getAuthControllerForgotPasswordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerForgotPassword>>,
    TError,
    { data: ForgotPasswordDto },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerForgotPassword>>,
  TError,
  { data: ForgotPasswordDto },
  TContext
> => {
  const mutationKey = ['authControllerForgotPassword']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerForgotPassword>>,
    { data: ForgotPasswordDto }
  > = (props) => {
    const { data } = props ?? {}

    return authControllerForgotPassword(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AuthControllerForgotPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerForgotPassword>>
>
export type AuthControllerForgotPasswordMutationBody = ForgotPasswordDto
export type AuthControllerForgotPasswordMutationError = ErrorType<unknown>

export const useAuthControllerForgotPassword = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerForgotPassword>>,
      TError,
      { data: ForgotPasswordDto },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerForgotPassword>>,
  TError,
  { data: ForgotPasswordDto },
  TContext
> => {
  const mutationOptions = getAuthControllerForgotPasswordMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const authControllerValidateResetPassword = (
  params: AuthControllerValidateResetPasswordParams,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<void>(
    { url: `https://api.detelio.ai/auth/validate-reset-password`, method: 'GET', params, signal },
    options,
  )
}

export const getAuthControllerValidateResetPasswordQueryKey = (
  params?: AuthControllerValidateResetPasswordParams,
) => {
  return [`https://api.detelio.ai/auth/validate-reset-password`, ...(params ? [params] : [])] as const
}

export const getAuthControllerValidateResetPasswordQueryOptions = <
  TData = Awaited<ReturnType<typeof authControllerValidateResetPassword>>,
  TError = ErrorType<unknown>,
>(
  params: AuthControllerValidateResetPasswordParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerValidateResetPassword>>, TError, TData>
    >
    request?: SecondParameter<typeof axiosClient>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAuthControllerValidateResetPasswordQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerValidateResetPassword>>> = ({
    signal,
  }) => authControllerValidateResetPassword(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authControllerValidateResetPassword>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthControllerValidateResetPasswordQueryResult = NonNullable<
  Awaited<ReturnType<typeof authControllerValidateResetPassword>>
>
export type AuthControllerValidateResetPasswordQueryError = ErrorType<unknown>

export function useAuthControllerValidateResetPassword<
  TData = Awaited<ReturnType<typeof authControllerValidateResetPassword>>,
  TError = ErrorType<unknown>,
>(
  params: AuthControllerValidateResetPasswordParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerValidateResetPassword>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerValidateResetPassword>>,
          TError,
          Awaited<ReturnType<typeof authControllerValidateResetPassword>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthControllerValidateResetPassword<
  TData = Awaited<ReturnType<typeof authControllerValidateResetPassword>>,
  TError = ErrorType<unknown>,
>(
  params: AuthControllerValidateResetPasswordParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerValidateResetPassword>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerValidateResetPassword>>,
          TError,
          Awaited<ReturnType<typeof authControllerValidateResetPassword>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthControllerValidateResetPassword<
  TData = Awaited<ReturnType<typeof authControllerValidateResetPassword>>,
  TError = ErrorType<unknown>,
>(
  params: AuthControllerValidateResetPasswordParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerValidateResetPassword>>, TError, TData>
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAuthControllerValidateResetPassword<
  TData = Awaited<ReturnType<typeof authControllerValidateResetPassword>>,
  TError = ErrorType<unknown>,
>(
  params: AuthControllerValidateResetPasswordParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerValidateResetPassword>>, TError, TData>
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAuthControllerValidateResetPasswordQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const authControllerResetPassword = (
  resetPasswordDto: ResetPasswordDto,
  options?: SecondParameter<typeof axiosClient>,
) => {
  return axiosClient<void>(
    {
      url: `https://api.detelio.ai/auth/reset-password`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: resetPasswordDto,
    },
    options,
  )
}

export const getAuthControllerResetPasswordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerResetPassword>>,
    TError,
    { data: ResetPasswordDto },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerResetPassword>>,
  TError,
  { data: ResetPasswordDto },
  TContext
> => {
  const mutationKey = ['authControllerResetPassword']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerResetPassword>>,
    { data: ResetPasswordDto }
  > = (props) => {
    const { data } = props ?? {}

    return authControllerResetPassword(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AuthControllerResetPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerResetPassword>>
>
export type AuthControllerResetPasswordMutationBody = ResetPasswordDto
export type AuthControllerResetPasswordMutationError = ErrorType<unknown>

export const useAuthControllerResetPassword = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerResetPassword>>,
      TError,
      { data: ResetPasswordDto },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerResetPassword>>,
  TError,
  { data: ResetPasswordDto },
  TContext
> => {
  const mutationOptions = getAuthControllerResetPasswordMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const authControllerResendEmail = (
  resendEmailBodyDto: ResendEmailBodyDto,
  options?: SecondParameter<typeof axiosClient>,
) => {
  return axiosClient<void>(
    {
      url: `https://api.detelio.ai/auth/resend-email`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: resendEmailBodyDto,
    },
    options,
  )
}

export const getAuthControllerResendEmailMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerResendEmail>>,
    TError,
    { data: ResendEmailBodyDto },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerResendEmail>>,
  TError,
  { data: ResendEmailBodyDto },
  TContext
> => {
  const mutationKey = ['authControllerResendEmail']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerResendEmail>>,
    { data: ResendEmailBodyDto }
  > = (props) => {
    const { data } = props ?? {}

    return authControllerResendEmail(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AuthControllerResendEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerResendEmail>>
>
export type AuthControllerResendEmailMutationBody = ResendEmailBodyDto
export type AuthControllerResendEmailMutationError = ErrorType<unknown>

export const useAuthControllerResendEmail = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerResendEmail>>,
      TError,
      { data: ResendEmailBodyDto },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerResendEmail>>,
  TError,
  { data: ResendEmailBodyDto },
  TContext
> => {
  const mutationOptions = getAuthControllerResendEmailMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const authControllerGoogleCallback = (
  params: AuthControllerGoogleCallbackParams,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<GoogleCallbackResponse>(
    { url: `https://api.detelio.ai/auth/google/callback`, method: 'GET', params, signal },
    options,
  )
}

export const getAuthControllerGoogleCallbackQueryKey = (params?: AuthControllerGoogleCallbackParams) => {
  return [`https://api.detelio.ai/auth/google/callback`, ...(params ? [params] : [])] as const
}

export const getAuthControllerGoogleCallbackQueryOptions = <
  TData = Awaited<ReturnType<typeof authControllerGoogleCallback>>,
  TError = ErrorType<unknown>,
>(
  params: AuthControllerGoogleCallbackParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerGoogleCallback>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAuthControllerGoogleCallbackQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerGoogleCallback>>> = ({ signal }) =>
    authControllerGoogleCallback(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authControllerGoogleCallback>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthControllerGoogleCallbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof authControllerGoogleCallback>>
>
export type AuthControllerGoogleCallbackQueryError = ErrorType<unknown>

export function useAuthControllerGoogleCallback<
  TData = Awaited<ReturnType<typeof authControllerGoogleCallback>>,
  TError = ErrorType<unknown>,
>(
  params: AuthControllerGoogleCallbackParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerGoogleCallback>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerGoogleCallback>>,
          TError,
          Awaited<ReturnType<typeof authControllerGoogleCallback>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthControllerGoogleCallback<
  TData = Awaited<ReturnType<typeof authControllerGoogleCallback>>,
  TError = ErrorType<unknown>,
>(
  params: AuthControllerGoogleCallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerGoogleCallback>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerGoogleCallback>>,
          TError,
          Awaited<ReturnType<typeof authControllerGoogleCallback>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthControllerGoogleCallback<
  TData = Awaited<ReturnType<typeof authControllerGoogleCallback>>,
  TError = ErrorType<unknown>,
>(
  params: AuthControllerGoogleCallbackParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerGoogleCallback>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAuthControllerGoogleCallback<
  TData = Awaited<ReturnType<typeof authControllerGoogleCallback>>,
  TError = ErrorType<unknown>,
>(
  params: AuthControllerGoogleCallbackParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerGoogleCallback>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAuthControllerGoogleCallbackQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const authControllerCompleteGoogleSignup = (
  googleSignupDto: GoogleSignupDto,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<AccessTokenResponse>(
    {
      url: `https://api.detelio.ai/auth/google/complete-signup`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: googleSignupDto,
      signal,
    },
    options,
  )
}

export const getAuthControllerCompleteGoogleSignupMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerCompleteGoogleSignup>>,
    TError,
    { data: GoogleSignupDto },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerCompleteGoogleSignup>>,
  TError,
  { data: GoogleSignupDto },
  TContext
> => {
  const mutationKey = ['authControllerCompleteGoogleSignup']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerCompleteGoogleSignup>>,
    { data: GoogleSignupDto }
  > = (props) => {
    const { data } = props ?? {}

    return authControllerCompleteGoogleSignup(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AuthControllerCompleteGoogleSignupMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerCompleteGoogleSignup>>
>
export type AuthControllerCompleteGoogleSignupMutationBody = GoogleSignupDto
export type AuthControllerCompleteGoogleSignupMutationError = ErrorType<unknown>

export const useAuthControllerCompleteGoogleSignup = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerCompleteGoogleSignup>>,
      TError,
      { data: GoogleSignupDto },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerCompleteGoogleSignup>>,
  TError,
  { data: GoogleSignupDto },
  TContext
> => {
  const mutationOptions = getAuthControllerCompleteGoogleSignupMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
